import React from "react";
import { ImageSearchServiceQuery } from "../../../services/query";
import { SCUIButton } from "../SCUIButton/SCUIButton";
import Swal from "sweetalert2";
import { t } from "i18next";

interface DownloadButtonProps {
  selectedItems: Array<any>;
  downloadLoading: any;
  setDownloadLoading: any;
}
export const SCUIDownloadImageComponent: React.FC<DownloadButtonProps> = ({
  selectedItems,
  setDownloadLoading,
}) => {
  const handleDownloadClick = async () => {
    if (selectedItems.length == 0) {
      Swal.fire(t("general.noSelectedDataFound"), " ", "error");

      return;
    }
    setDownloadLoading(true);
    const request: any = {};
    const imgUrls = selectedItems.map((item) => {
      const { specialCode, colorCode, imagePathIndexMetas } = item;
      const { uri } = imagePathIndexMetas;
      return {
        url: uri,
        specialCode,
        colorCode,
      };
    });
    request.selectedImages = imgUrls;
    try {
      const blob: any = await ImageSearchServiceQuery.DownloadImage(request);
      if (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `images-${Date.now()}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download error:", error);
      Swal.fire(t("general.error"), "İndirme sırasında bir hata oluştu.", "error");
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <SCUIButton
      onClick={handleDownloadClick}
      type="primary"
      sizeType="fixed"
      size="l"
      text={`Dışa Aktar (${selectedItems.length})`}
    />
  );
};
